import { Module } from 'vuex';
import RootState from '../../state';
import { listUsingPOST, settingsUsingGET } from '@services/merchant/notify-center-controller';
import { INotifyVO, INotifySettingsVO } from '@services/merchant/model';

interface IState {
    notifyList: INotifyVO[];
    notifyPageTotal: number;
    notifySettings: INotifySettingsVO;
    notifyNum: number;
    enableOrderBell: boolean;
    enableOrderNumberSign: boolean;
    enableOrderPop: boolean;
    orderBellEmitCount: number;
}

const intialState = {
    notifyList: [] as INotifyVO[],
    notifyPageTotal: 0,
    notifySettings: {} as INotifySettingsVO,
    notifyNum: 0,
    enableOrderBell: false,
    enableOrderNumberSign: true,
    enableOrderPop: false,
    orderBellEmitCount: 0,
};

const notificationStore: Module<IState, RootState> = {
    namespaced: true,
    state: intialState,
    mutations: {
        setNotifyData(state: typeof intialState, { notifies, total }) {
            state.notifyList = notifies;
            state.notifyPageTotal = total;
        },
        setNotifySettings(state: typeof intialState, data) {
            state.notifySettings = data;
        },
        setNotifyNum(state: typeof intialState, data) {
            state.notifyNum = data;
        },
        setEnableOrderBell(state: typeof intialState, data) {
            state.enableOrderBell = data;
        },
        setEnableOrderNumberSign(state: typeof intialState, data) {
            state.enableOrderNumberSign = data;
        },
        setEnableOrderPop(state: typeof intialState, data) {
            state.enableOrderPop = data;
        },
        setOrderBellEmitCount(state: typeof intialState, data) {
            state.orderBellEmitCount = data;
        },
    },
    actions: {
        async getNotifyList({ commit }, payload) {
            const { data } = await listUsingPOST({
                param: {
                    ...payload,
                },
            });
            if (data) {
                const { notifies, total } = data;
                commit('setNotifyData', { notifies, total });
            }
        },
        async getNotifySettings({ commit }, payload) {
            const { data } = await settingsUsingGET();
            if (data) {
                commit('setNotifySettings', data);
                console.log(data);
                commit('setEnableOrderBell', data?.orderBell?.enabled);
                commit('setEnableOrderNumberSign', data?.orderNumberSign?.enabled);
                commit('setEnableOrderPop', data?.orderPop?.enabled);
            }
        },
    },
};

export default notificationStore;
